import { render } from "./BubbleHeadline.vue?vue&type=template&id=a03ff10e&scoped=true"
import script from "./BubbleHeadline.vue?vue&type=script&lang=js"
export * from "./BubbleHeadline.vue?vue&type=script&lang=js"

import "./BubbleHeadline.vue?vue&type=style&index=0&id=a03ff10e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a03ff10e"]])

export default __exports__